import { Component, EventEmitter, HostListener, Inject, Injector, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SecurityService } from 'src/app/services/security.service';
import { DataService } from 'src/app/services/data.service'
import { SummaryService } from 'src/app/services/summary.service'
import { DialogAfinComponent } from 'src/app/pages/cotiza/cotiza-components/dialog-afin/dialog-afin.component';
import { DecimalPipe } from '@angular/common'
import { WINDOW } from 'src/app/utils/window';
import { Platform } from '@angular/cdk/platform';
import { CreditDialogComponent } from '../credit-dialog/credit-dialog.component';
import { CreditTypeDialogComponent } from '../credit-type-dialog/credit-type-dialog.component';
import { TypeProduct, TypeQuote, TypeQuoter } from 'src/app/utils/utils';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-card-car-home',
  templateUrl: `./card-car-home.component${environment.templateSuffix}.html`,
  styleUrls: ['./card-car-home.component.scss']
})
export class CardCarHomeComponent {
  @Output() public destroyQuoter = new EventEmitter();
  @Input() car!: any;
  @Input() ofPage!: string;
  @Input() isAfin: any;
  @Input() closeSide!: boolean;
  @Input() topCar!: boolean;
  @Input() productType: string = "";

  urlStrapiBase = `${environment.strappiUrl}`;
  public screenWidth: any = this.window.innerWidth;
  public screenHeight: any = this.window.innerHeight;
  private platform: Platform;
  private dialog: MatDialog;
  private router: Router;
  templateSuffix: string = '';
  private domSanitizer: DomSanitizer;
  private matIconRegistry: MatIconRegistry;



  constructor(
    private security: SecurityService,
    private dataService: DataService,
    public summaryService: SummaryService,
    private decimalPipe: DecimalPipe,
    @Inject(WINDOW) private window: Window,
    private injector: Injector,
  ) {

    this.platform = this.injector.get<Platform>(Platform);
    this.dialog = this.injector.get<MatDialog>(MatDialog);
    this.router = this.injector.get<Router>(Router);

    this.domSanitizer = this.injector.get<DomSanitizer>(DomSanitizer);
    this.matIconRegistry = this.injector.get<MatIconRegistry>(MatIconRegistry);


    this.matIconRegistry.addSvgIcon('spec-automatica', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-automatica.svg"));
    this.matIconRegistry.addSvgIcon('spec-electrico', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-electrico.svg"));
    this.matIconRegistry.addSvgIcon('spec-gasolina', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-gasolina.svg"));
    this.matIconRegistry.addSvgIcon('spec-manual', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-manual.svg"));
    this.matIconRegistry.addSvgIcon('spec-hibrido', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-hibrido.svg"));
    this.matIconRegistry.addSvgIcon('spec-kilometraje', this.domSanitizer.bypassSecurityTrustResourceUrl("./assets/img/v3/leasing-icono-especs-kilometraje.svg"));
    

    this.templateSuffix = environment.templateSuffix;

  }

  navigateTo(car: any) {
    localStorage.removeItem('dataQuote');
    if (this.ofPage === 'seminuevos') {
      this.window.open(car.link, '_blank');
    } else if (this.isAfin === undefined) {
      this.validateFlow(car);
    } else {
      switch (this.productType) {
        case TypeProduct.LeasingRenting:
            this.goNextPage(car, this.isAfin);
          break;
        case TypeProduct.Rent2buy:
            this.goNextPage(car, this.isAfin);
          break;
        case TypeProduct.Ballon:
            this.goNextPage(car, true, true);
          break;
        case TypeProduct.Traditional:
            this.goNextPage(car, false, true);
          break;
        default:
            this.validateFlow(car);
          break;
      }
    }
  }


  /**
   * Validates the flow based on the template suffix.
   * If the template suffix is not empty, it redirects to the cotizador page for RR for FORD Campaign.
   * Otherwise, it opens the dialog for Afin.
   *
   * @param car - The car object to be processed.
   * @returns void
   * @memberof CardCarHomeComponent
   * @author victor.mendez
   */
  validateFlow(car:any) {
    if(this.templateSuffix !== ''){
      this.goNextPage(car, true);
    } else {
      this.opendDialogAfin(car);
    }
  }

  opendDialogAfin(car: any) {
    let dialogAfin = this.dialog.open(
      CreditDialogComponent,
      {
        disableClose: false
      }
    );

    dialogAfin.afterClosed().subscribe(res => {
      switch (res) {
        case TypeQuote.Leasing:
            this.goLeasing(car); 
          break;
        case TypeQuote.credit:
            this.goCredit(car); 
          break;
        default:
          break;
      }
    })
  }

  public goLeasing(car: any){
    let dialogAfin = this.dialog.open(DialogAfinComponent,{
      disableClose: false
    });
    dialogAfin.afterClosed().subscribe(res => {
      if (res !== undefined)
        this.goNextPage(car, res)
    })
  }

  /* TODO: FASE 2 */
  public goCredit(car: any){
    let dialogAfin = this.dialog.open(CreditTypeDialogComponent,{
      disableClose: false
    });
    dialogAfin.afterClosed().subscribe(res => {
      if (res !== undefined)
        this.goNextPage(car, res, true);       
    })
  }


  getHyphenatedUrl(urlFriendly: string) {
    return urlFriendly.replace(",", "").replace(/[^\w\s]/gi, '').replace(/[()]/g, '').replace(/\s+/g, '-').toLowerCase();
  }

  goNextPage(car: any, type: boolean, isCredit:boolean = false) {
    if (this.ofPage === 'cotizador')
      this.destroyQuoter.emit();

    const carId = car.idLeaseTech!
    this.dataService.setCarIdQuoter(carId);

    let urlHash = this.security.encryptData({ carId, isAfin:type }, false)

    let producto = isCredit ? (type ? TypeProduct.Ballon : TypeProduct.Traditional) : (type ? TypeProduct.Rent2buy : TypeProduct.LeasingRenting);
    let queryParams: any = {
      quote: urlHash,
      share_title: `${car.brand} ${car.subBrand} en BitCar`,
      share_desc: `${car.brand} ${car.subBrand} ${car.version} ${car.year} desde ${this.decimalPipe.transform(car.rentingMin, "1.2")} mensuales`,
      slashed_url: `${this.getHyphenatedUrl(car.brand)}/${this.getHyphenatedUrl(car.subBrand)}/${this.getHyphenatedUrl(car.version)}/${car.year.toString()}/${producto}`
    }

    if (car.imagenes?.length > 0)
      queryParams.share_img = this.summaryService.imgCarCard(car);

    const typeQuoter = isCredit ? TypeQuoter.Credit : TypeQuoter.Quoter;
    this.router.navigate([`/${typeQuoter}/${this.getHyphenatedUrl(car.brand)}/${this.getHyphenatedUrl(car.subBrand)}/${this.getHyphenatedUrl(car.version)}/${car.year.toString()}/${producto}`], { queryParams, replaceUrl: this.ofPage === 'cotizador' })
  }


  isMobile() {
    return this.screenWidth < 768 || this.platform.ANDROID || this.platform.IOS
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(): void {
    this.screenWidth = this.window.innerWidth;
    this.screenHeight = this.window.innerHeight;
    this.isMobile();
  }

}
